// extracted by mini-css-extract-plugin
module.exports = {"cont":"MyPageCompanyCreateInput_cont__2uS0a","box":"MyPageCompanyCreateInput_box__1x4EJ","sm":"MyPageCompanyCreateInput_sm__204Ij"};